import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { post, get } from '../helpers/fetchSagaAPI';
import { PAGINATED_EPISODE_LIMIT, PAGINATED_RATINGS_LIMIT } from '../helpers/episodes';
import { getSoundcastItunesImageUrl } from '../helpers/soundcasts';

export const getSoundcastsEpisodes = params => {
  return new Promise(async (resolve, reject) => {
    try {
      const {
        soundcastId = '',
        page = 1,
        limit = PAGINATED_EPISODE_LIMIT,
        filter = {},
        offset = -1,
      } = params;

      if (isEmpty(soundcastId)) {
        throw new Error(`Unable to retrieve tracks with empty soundcastId`);
      }

      const { status, data } = await Axios.get(`/api/soundcast/${soundcastId}/episodes`, {
        params: {
          offset: offset < 0 ? (page - 1) * limit : offset,
          limit,
          total: true,
          state: true,
          filter: { where: { url: { $ne: null } }, order: [['index', 'DESC'],['episodeId', 'DESC']], ...filter },
        },
      });

      if (status === 200) {
        resolve(data);
      } else {
        throw new Error(`Unable to retrieve tracks with unknown status ${status}`);
      }
    } catch (err) {
      reject(err);
    }
  });
};

export const updateSoundcastFeed = function* (soundcast, user) {
  const { id: soundcastId, itunesCategory, itunesExplicit } = soundcast;
  return yield post('/api/create_feed', {
    soundcastId,
    itunesExplicit,
    itunesImage: getSoundcastItunesImageUrl(soundcast),
    itunesCategory,
    email: user.publisher.email,
    firstName: user.firstName,
  });
};

export const getSoundcastRatingsOverview = function* (soundcastId) {
  return yield get(`/api/rating/soundcast/${soundcastId}/overview`);
};

export const getSoundcastRatings = (
  soundcastId = '',
  page = 1,
  limit = PAGINATED_RATINGS_LIMIT,
  filter = {}
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const offset = (page - 1) * limit;
      const { status, data } = await Axios.get(`/api/rating/soundcast/${soundcastId}`, {
        params: {
          offset,
          limit,
          total: true,
          filter: { order: [['ratingId', 'DESC']], ...filter },
        },
      });

      if (status === 200) {
        resolve(data);
      } else {
        throw new Error(`Unable to retrieve ratings with unknown status ${status}`);
      }
    } catch (err) {
      reject(err);
    }
  });
};

export const updateSoundcastsOrder = function* (publisherID, soundcasts) {
  const indexes = soundcasts.reduce(function (accum, soundcast, orderIdx) {
    accum[`${soundcast.soundcastId}`] = { orderIdx };
    return accum;
  }, {});

  return yield post(`/api/v2/library/publishers/${publisherID}/order`, {
    indexes,
  });
};

export const updateBundleSoundcastsOrder = function* (bundleId, soundcastsIdx) {
  const indexes = soundcastsIdx.reduce(function (accum, soundcastId, orderIdx) {
    accum[`${soundcastId}`] = { orderIdx };
    return accum;
  }, {});

  return yield post(`/api/v2/bundles/${bundleId}/soundcasts/order`, {
    indexes,
  });
};

export const getSoundcastsOrder = function* (publisherID, type = '') {
  // app.get('/api/v2/library/publishers/:id/', listPublisherLibrary);
  // app.get('/api/v2/library/publishers/:id/:type(bundles|individuals)', listPublisherLibrary);

  return new Promise(async (resolve, reject) => {
    try {
      const urlEnd = type ? (type === 'bundles' ? 'bundles/' : 'individuals/') : '';
      // const url = `/api/v2/library/publishers/${publisherID}/${urlEnd}`;
      const url = `/api/v2/adminlibrary/publishers/${publisherID}/${urlEnd}`;

      const { status, data } = await Axios.get(url);

      if (status === 200) {
        resolve(data);
      } else {
        throw new Error(`Unable to retrieve publishers soundcasts with unknown status ${status}`);
      }
    } catch (err) {
      reject(err);
    }
  });
};

export const getSoundcastsList = function* (publisherID, type = '') {
  // app.get('/api/v2/library/publishers/:id/', listPublisherLibrary);
  // app.get('/api/v2/library/publishers/:id/:type(bundles|individuals)', listPublisherLibrary);

  const urlEnd = type ? (type === 'bundles' ? 'bundles/' : 'individuals/') : '';
  // return yield get(`/api/v2/library/publishers/${publisherID}/${urlEnd}`);
  return yield get(`/api/v2/adminlibrary/publishers/${publisherID}/${urlEnd}`);
};

export const getBundleSoundcastsOrder = function* (soundcastId) {
  // app.get('/api/v2/bundles/:id/soundcasts', listBundle);

  return new Promise(async (resolve, reject) => {
    try {
      const { status, data } = await Axios.get(`/api/v2/bundles/${soundcastId}/soundcasts/`);

      if (status === 200) {
        resolve(data);
      } else {
        throw new Error(
          `Unable to retrieve publishers bundle soundcasts with unknown status ${status}`
        );
      }
    } catch (err) {
      reject(err);
    }
  });
};
